import { TransportSettingsApi, TransportsQueryApi } from 'graphql/generated';
import { ImageType } from 'types/image';
import { PaymentType } from 'types/payment';
import { PickupPointType } from 'types/pickupPoint';
import { PriceType } from 'types/price';

export type MappedTransportType = {
    uuid: string;
    name: string;
    description: string;
    instruction: string;
    price: PriceType;
    mainImage: ImageType | null;
    payments: PaymentType[];
    daysUntilDelivery: number;
    deliveryDaysFromCentralStore: string | null;
    isPersonalPickup: boolean;
    stores: PickupPointType[];
    transportType: {
        code: string;
    };
    disabled: boolean;
    isDeliveryDateDisplayed: boolean;
    postcodeLimitationMode: string | null;
    postcodeLimitation: string | null;
    settings: TransportSettingsApi;
};

export type TransportType = MappedTransportType | TransportsQueryApi['transports'][0];

export enum TransportTypeCodeEnum {
    COMMON = 'common',
    PACKETERY = 'packetery',
    PACZKOMAT = 'paczkomat',
    BALIKOVNA = 'balikovna',
    PPL = 'ppl',
    POST_OFFICE_PARCEL_DELIVERY_CZ = 'postOfficeParcelDelivery',
    POST_OFFICE_PARCEL_DELIVERY_HU = 'postOfficeParcelDeliveryHu',
    POST_OFFICE_PARCEL_DELIVERY_SK = 'postOfficeParcelDeliverySk',
    PBH = 'pbh',
    DPD = 'dpd',
}

export enum PostcodeLimitationMode {
    ALLOW = 'allow',
    DENY = 'deny',
}
